import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import jwt_decode from "jwt-decode";
import setAuthToken from "./utils/setAuthToken";
import { setCurrentUser, logoutUser } from "./actions/authActions";
import { Provider } from "react-redux";
import store from "./store";
import axios from "axios";
import Login from "./components/auth/Login";
import PrivateRoute from "./components/private-route/PrivateRoute";
import Dashboard from "./components/dashboard/Dashboard";
import { SnackbarProvider } from 'notistack';
import { getSelectedRegion } from "./constants";
import ErrorBoundary from "./components/ErrorBoundary";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

const region = getSelectedRegion();
if (process.env.NODE_ENV === 'development') {
  console.log('Development mode: using proxy for API calls');
  axios.defaults.baseURL = '/';
} else {
  console.log(`Production mode: setting API base URL to ${region}-turing.hyperverge.co`);
  axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL || `https://${region}-turing.hyperverge.co`;
}

// Check for token to keep user logged in
if (localStorage.jwtToken) {
  // Set auth token header auth
  const token = localStorage.jwtToken;
  setAuthToken(token);

  // Decode token and get user info and exp
  const decoded = jwt_decode(token);

  // Set user and isAuthenticated
  store.dispatch(setCurrentUser(decoded));

  // Check for expired token
  const currentTime = Date.now() / 1000; // to get in milliseconds

  if (decoded.exp < currentTime) {
    // Logout user
    store.dispatch(logoutUser());

    // Redirect to login
    window.location.href = "./login";
  }
}
function Status({ code, children }) {
  return (
    <Route
      render={({ staticContext }) => {
        if (staticContext) staticContext.status = code;
        return children;
      }}
    />
  );
}
function Aok() {
  return (
    <Status code={200}>
      <div>
        <h1>Aok!</h1>
      </div>
    </Status>
  );
}
function App() {
  const notistackRef = React.createRef();
  return (
    <SnackbarProvider
      maxSnack={4}
      ref={notistackRef}
      action={(key) => (
        <IconButton
          size="small"
          onClick={() => notistackRef.current.closeSnackbar(key)}
          style={{ color: '#fff', padding: 4 }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    >
      <Provider store={store}>
        <Router>
          <div className="App">
            <ErrorBoundary>
              <Route exact path="/login" component={Login} />
              <Route exact path="/healthcheck" component={Aok} />
              <Switch>
                <PrivateRoute path="/" component={Dashboard} />
              </Switch>
            </ErrorBoundary>
          </div>
        </Router>
      </Provider>
    </SnackbarProvider>
  );
}

export default App;
